<script setup lang="ts">
  declare const Cookiebot: any

  import type { ILegalLink } from '@/components/main-footer/types'

  defineProps<{
    legalLinks: ILegalLink[] | null
  }>()

  const changePreferences = () => Cookiebot.show()
</script>

<template>
  <ul class="flex list-none flex-col gap-4 p-0 sm:flex-row">
    <li
      v-for="item in legalLinks"
      :key="item.text"
    >
      <NuxtLink
        :to="item.href"
        :title="item.text"
        class="text-sm/5 no-underline"
        external
      >
        {{ item.text }}
      </NuxtLink>
    </li>
    <li>
      <button
        :title="$t('footer.changeCookiePreferences')"
        class="text-sm/5 no-underline"
        @click="changePreferences"
      >
        {{ $t('footer.changeCookiePreferences') }}
      </button>
    </li>
  </ul>
</template>
